<template>
  <div class="main">
    <transition name="fade">
      <div v-if="loading" class="loader">
        <div class="text">{{ $t("message.loading") }}</div>
        <Loader/>
      </div>
    </transition>

    <div class="row top"  style="padding-top:10px">

      <div class="px-0 col-lg-5 col-md-7 col-sm-12">
        <div class="row">
          <div class="col-md-12">

            <div class="button" style="width: 475px;">
              <button class="btn btn-primary btn-block" style="font-size: 0.7em;width: 200px;" @click="downloadIt">
                <i class="fa fa-file-pdf"></i>&nbsp;&nbsp; <template v-if="listType == 'pulsar'">{{ $t("message.title") }}</template><template v-else>{{ $t("message.titleMW") }}</template></button>
            </div>

            <div class="download-text">
              <h4>{{ $t("message.download_pricelist") }}:</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-3 col-6">
            <div class="button">
              <PdfExport/>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-6">
            <div class="button">
              <XmlExport/>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-6">
            <div class="button">
              <XlsExport/>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-6">
            <div class="button">
              <CsvExport/>
            </div>
          </div>
        </div>
      </div>

      <div class="px-0 col-lg-2 col-md-1 col-sm-12">
        <div class="button" style="width: max-content;height: 34px;">
        </div>
        <div class="discount">
          <Discount/>
        </div>
      </div>

      <div class="px-0 col-lg-5 col-md-7 col-sm-12">
        <div class="row">
          <div class="col-md-12">

            <div class="button" style="width: 100%;display:block">
              <button class="btn btn-primary btn-block" style="font-size: 0.7em;width: 40%;float: left;margin-right: 10px;" @click="showTables">
                <i class="fa fa-file-pdf"></i>&nbsp;&nbsp; {{ $t("message.show_summary_tables") }}</button>
              <button class="btn btn-primary btn-block" style="font-size: 0.7em; background: #388e57;color: #fff;border-color: #388e57;; width:45%"
              @click="getTablesXls">
                <i class="fa fa-file-excel"></i>&nbsp;&nbsp;{{ $t("message.show_summary_tables") }} XLS</button>
            </div>

            <div class="download-text">
              <h4>{{ $t("message.summary_tables") }}:</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-2 col-sm-2 col-6 windowTab">
            <div class="button">
              <Sales/>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-6 windowTab">
            <div class="button">
              <Rises/>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-6 windowTab">
            <div class="button">
              <Reductions/>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-6 windowTab">
            <div class="button">
              <News/>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-6 windowTab">
            <div class="button">
              <Promotions/>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="px-0 col-lg-5 col-md-7 col-sm-12">
        <div class="px-1 col-lg-3 col-md-1 col-sm-6 col-6">
          <div class="sales">
            <div class="button">
              <Sales/>
            </div>
          </div>
        </div>

        <div class="px-1 col-lg-3 col-md-1 col-sm-6 col-6">
          <div class="sales">
            <div class="button">
              <Rises/>
            </div>
          </div>
        </div>

        <div class="px-1 col-lg-3 col-md-1 col-sm-6 col-6">
          <div class="sales">
            <div class="button">
              <Reductions/>
            </div>
          </div>
        </div>

        <div class="px-1 col-lg-3 col-md-1 col-sm-6 col-6">
          <div class="sales">
            <div class="button">
              <News/>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <Search/>

    <div class="row toc">
      <div class="col-md-12">
        <TableOfContents :categories="items"/>
      </div>
    </div>

    <div class="row">
      <div v-if="loading" class="loading">
        <p>{{ $t("message.loading") }}</p>
      </div>
      <div class="content" v-else>
        <Category v-for="item in items" :key="item.id" :c="item"></Category>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import Loader from "./Loader.vue";
import Search from "./Search/Search.vue";
import Category from "./Category.vue";
import PdfExport from "./Export/PdfExport.vue";
import XmlExport from "./Export/XmlExport.vue";
import XlsExport from "./Export/XlsExport.vue";
import CsvExport from "./Export/CsvExport.vue";
import Discount from "./Discount/Discount.vue";
import Sales from "./Sales/Sales.vue";
import Rises from "./Rises/Rises.vue";
import Reductions from "./Reductions/Reductions.vue";
import News from "./News/News.vue";
import Phone from "./Phone/Phone.vue";
import Promotions from "./Promotions/Promotions.vue";
import TableOfContents from "./TableOfContents/TableOfContents.vue";

import {mapGetters} from 'vuex'

export default {
  data(){
    return{
      //Pulsar_Pricelist_v1.09.9.pdf Pulsar_Cennik_v1.09.9.pdf
      link: (this.$i18n.locale == 'pl') ?
        ((this.listType == 'pulsar') ? process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_Cennik_.pdf" : process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_Cennik_MW.pdf") :
        ((this.listType == 'pulsar') ? process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_Pricelist_.pdf" : process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_Pricelist_.pdf"),
    }
  },
  components: {
    Loader,
    Search,
    Category,
    PdfExport,
    XmlExport,
    XlsExport,
    CsvExport,
    Discount,
    Sales,
    Rises,
    Reductions,
    News,
    Promotions,
    Phone,
    TableOfContents
  },
  name: "Main",
  computed: {
    ...mapGetters('pricelist', ['listType']),
    items() {
      return this.$store.getters["pricelist/items"]; // 0 - parent ID
    },
    products() {
      return this.$store.getters["pricelist/products"]; // 0 - parent ID
    },
    loading() {
      return this.$store.getters["pricelist/loading"];
    },
    links(){
      return (this.$i18n.locale == 'pl') ?
        ((this.listType == 'pulsar') ? process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_Cennik_"+this.$store.state.version.version.numer+".pdf" : process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_MW_Cennik_"+this.$store.state.version.version.numer+".pdf") :
        ((this.listType == 'pulsar') ? process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_Pricelist_"+this.$store.state.version.version.numer+".pdf" : process.env.VUE_APP_ROOT_DOWNLOAD+"Pulsar_MW_Pricelist_"+this.$store.state.version.version.numer+".pdf");
    }
  },
  methods: {
    downloadIt () {

      let userSession = sessionStorage.getItem("userLog");
      let obj = JSON.parse((userSession));

      console.log(this.listType)
      console.log(this.$store.state.version)

      let file_name = (this.$i18n.locale == 'pl') ?
        ((this.listType == 'pulsar') ? "Pulsar_Cennik_"+this.$store.state.version.version.pulsarNumer+".pdf" : "Pulsar_MW_Cennik_"+this.$store.state.version.version.mwNumer+".pdf") :
        ((this.listType == 'pulsar') ? "Pulsar_Pricelist_"+this.$store.state.version.version.pulsarNumer+".pdf" : "Pulsar_MW_Pricelist_"+this.$store.state.version.version.mwNumer+".pdf");

      this.$http.get('https://app.pulsar.pl/api/pobierz', {responseType: 'blob', params:{
        email: (obj && obj.email) ? obj.email : "grzegorzj@pulsar.pl",
        file: file_name,
        lang: this.$i18n.locale
      }})
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_name); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    },
    downloadItDistributes() {
      let userSession = sessionStorage.getItem("userLog");
      let obj = JSON.parse((userSession));

      let file_name = (this.$i18n.locale == 'pl') ?
        ((this.listType == 'pulsar') ? "Pulsar_Cennik_Detal_"+this.$store.state.version.version.numer+".pdf" : "Pulsar_MW_Cennik_Detal_"+this.$store.state.version.version.numer+".pdf") :
        ((this.listType == 'pulsar') ? "Pulsar_Pricelist_Detal_"+this.$store.state.version.version.numer+".pdf" : "Pulsar_MW_Pricelist_Detal_"+this.$store.state.version.version.numer+".pdf");

      this.$http.get('https://app.pulsar.pl/api/pobierz', {responseType: 'blob', params:{
        email: (obj && obj.email) ? obj.email : "grzegorzj@pulsar.pl",
        file: file_name,
        lang: this.$i18n.locale
      }})
        .then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_name); //or any other extension
            document.body.appendChild(link);
            link.click();

        });
    },

    showTables(){
      // window.open('https://app.pulsar.pl/api/alltabs/'+this.$i18n.locale+'/'+this.listType, '_blank');
      window.open(this.axios.defaults.baseURL +'pricelist/alltabs/'+this.$i18n.locale+'/'+this.listType, '_blank');
    },
    getTablesXls () {
      const columns = [ "code", "name", "price" ];

      var names = [];
      if (this.$i18n.locale == 'pl') {
        names = [ "Kod_produktu", "Nazwa_produktu", "Cena_PLN" ];
      } else {
        names = [ "Product_code", "Product_name", "Price_EUR" ];
      }

      var url = (
          this.axios.defaults.baseURL +
          "pricelist" +
          '?company=' + this.listType +
          "&format=xlsx" +
          '&discount=0' +
          "&columns=" +
          columns +
          "&names=" +
          names +
          "&lang=" +
          this.$i18n.locale
        )
      location.href = url;
    }
    // http://127.0.0.1:8081/pricelist?format=xlsx&discount=0&columns=code,name,price&names=Kod_produktu,Nazwa_produktu,Cena_PLN&lang=pl
  },
  created() {
    this.$store.dispatch("pricelist/set_locale", this.$i18n.locale);
    this.$store.dispatch("pricelist/load_all_async", this.listType)
    .then(() => {
    this.$store.dispatch("pricelist/load_products_async", this.listType)
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

  .windowTab {
  padding-right: 12px;
  padding-left: 10px;
  }

  .btn-group-sm > .btn, .btn-sm{
    padding: .15rem .5rem;
  }
  .btn-primary,
  .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    background: #f15642;
    color: #fff;
    border-color: #f15642;
  }
  .download_file{
    font-size:0.6em; color:#2c3e50; text-decoration: none
  }
  .download_file:hover{
    color:#dc3545;
  }
  .main {
  background: #fff;
  padding: 0 30px;
  .loader {
    display: block;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: -moz-radial-gradient(
      center,
      ellipse cover,
      rgba(0, 0, 0, 0.78) 0%,
      rgba(0, 0, 0, 0.78) 1%,
      rgba(0, 0, 0, 0.82) 100%
    );
    background: -webkit-radial-gradient(
      center,
      ellipse cover,
      rgba(0, 0, 0, 0.78) 0%,
      rgba(0, 0, 0, 0.78) 1%,
      rgba(0, 0, 0, 0.82) 100%
    );
    background: radial-gradient(
      ellipse at center,
      rgba(0, 0, 0, 0.78) 0%,
      rgba(0, 0, 0, 0.78) 1%,
      rgba(0, 0, 0, 0.82) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#c7000000', endColorstr='#d1000000',GradientType=1 );
    z-index: 999999;
    color: #fff;
    text-align: center;
    .text {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: auto 0;
    }
    .animation {
      position: absolute;
      top: 55%;
      left: 0;
      right: 0;
      margin: auto;
    }
  }

  .top {
    padding: 30px 0;
    .download-text {
      h4 {
        font-size: 0.5em;
        text-align: center;
        @media (min-width: 768px) {
          text-align: left;
          font-size: .8em;
        }
      }
    }
    .button {
      margin-top: 7.5px;
      @media (min-width: 768px) {
        margin-top: 0;
      }
    }
    .discount {
      padding: 30px 0 0 0;
      @media (min-width: 768px) {
        padding: 0 0 0 15px;
      }
      @media (min-width: 992px) {
        padding: 0px 15px 0 30px;
      }
    }
    .print {
      padding-top: 32px;
    }
    .sales {
      margin-top: 3.75px;
      @media (min-width: 768px) {
        margin-top: 32.5px;
      }
    }
  }
  .storage {
    color: #23497f;
  }
  .toc {
    background: #f1f1f1;
  }
  .loading {
    p {
      text-align: center;
      padding: 120px 0;
    }
  }
  .content {
    width: 100%;
    margin-top: 60px;
  }
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
  li {
    display: inline-block;
    margin: 0 10px;
  }
}
a {
  color: #42b983;
}
// Transition - fade
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-slow-enter-active,
.fade-slow-leave-active {
  transition: opacity 0.25s;
}
.fade-slow-enter, .fade-slow-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue